import SupplierLayout from '../../components/layout/SupplierLayout';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Settings, Bell, Globe, Shield } from 'lucide-react';
import { useSupplierAuth } from '../../context/SupplierAuthContext';

const SupplierSettingsPage = () => {
  const { user } = useSupplierAuth();

  const settings = [
    { icon: Bell, label: 'Notificaties', description: 'E-mailmeldingen bij nieuwe aanvragen en beoordelingen', value: 'Aan' },
    { icon: Globe, label: 'Zichtbaarheid', description: 'Uw profiel is zichtbaar voor klanten in de marketplace', value: 'Publiek' },
    { icon: Shield, label: 'Beveiligingsniveau', description: 'Tweefactorauthenticatie en sessieduur', value: 'Standaard' },
  ];

  return (
    <SupplierLayout>
      <div className="space-y-6" data-testid="supplier-settings-page">
        <div>
          <h1 className="text-xl font-bold text-black tracking-tight">Instellingen</h1>
          <p className="text-sm text-neutral-500 mt-1">Beheer uw leveranciersportaal instellingen</p>
        </div>

        <Card className="border-neutral-200 shadow-sm">
          <CardHeader className="pb-3">
            <CardTitle className="text-sm font-bold text-black flex items-center gap-2">
              <Settings className="h-4 w-4" strokeWidth={1.5} />
              Algemene instellingen
            </CardTitle>
          </CardHeader>
          <CardContent className="p-0">
            <div className="divide-y divide-neutral-100">
              {settings.map((s, i) => (
                <div key={i} className="p-4 flex items-center justify-between hover:bg-neutral-50 transition-colors">
                  <div className="flex items-center gap-3">
                    <div className="h-9 w-9 rounded-lg bg-neutral-100 flex items-center justify-center">
                      <s.icon className="h-4 w-4 text-neutral-600" strokeWidth={1.5} />
                    </div>
                    <div>
                      <p className="text-sm font-medium text-black">{s.label}</p>
                      <p className="text-xs text-neutral-500">{s.description}</p>
                    </div>
                  </div>
                  <Badge variant="outline" className="text-[10px]">{s.value}</Badge>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>

        <Card className="border-amber-200 bg-amber-50/50 shadow-sm">
          <CardContent className="p-4 flex items-center gap-3">
            <div className="h-10 w-10 rounded-lg bg-amber-100 flex items-center justify-center shrink-0">
              <Settings className="h-5 w-5 text-amber-600" strokeWidth={1.5} />
            </div>
            <div>
              <p className="text-sm font-semibold text-amber-800">Instellingen worden uitgebreid</p>
              <p className="text-xs text-amber-700">Meer configuratieopties zoals notificatievoorkeuren en API-koppelingen worden binnenkort toegevoegd.</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </SupplierLayout>
  );
};

export default SupplierSettingsPage;
